module.exports = __webpack_public_path__ + "images/emoji/date.ebe5fa4c382e8aa2eba5.png";